// Material Dashboard 2 PRO React TS Base Styles
import boxShadows from '@theme/base/boxShadows';
import typography from '@theme/base/typography';
import colors from '@theme/base/colors';
import borders from '@theme/base/borders';

// Material Dashboard 2 PRO React TS Helper Functions
import pxToRem from '@theme/functions/pxToRem';

const { lg } = boxShadows;
const { size } = typography;
const { text, white } = colors;
const { borderRadius } = borders;

// types
type Types = any;

const menu: Types = {
  defaultProps: {
    disableAutoFocusItem: true
  },

  styleOverrides: {
    paper: {
      minWidth: pxToRem(160),
      boxShadow: lg,
      padding: `${pxToRem(16)} ${pxToRem(8)}`,
      fontSize: size.sm,
      color: text.main,
      textAlign: 'left',
      backgroundColor: `${white.main} !important`,
      borderRadius: borderRadius.md
    }
  }
};

export default menu;
